Drupal.behaviors.redeemCode = {
  attach(context) {
    const redeemCodeInput = context.getElementById('redeemCode');
    const redeemCodeButton = context.getElementById('redeemCodeButton');

    redeemCodeButton.addEventListener('click', (e) => {
      e.preventDefault();
      const url = `http://${window.location.hostname}/download/${redeemCodeInput.value}`;
      window.location = url;
    });
  },
};
